const autoNgTemplateLoaderTemplate1 = require('./containerNetworksDatatable.html');

angular.module('shbdeployer.docker').component('containerNetworksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'ContainerNetworksDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    container: '<',
    availableNetworks: '<',
    joinNetworkAction: '<',
    joinNetworkActionInProgress: '<',
    leaveNetworkActionInProgress: '<',
    leaveNetworkAction: '<',
    nodeName: '<',
  },
});
